<template>
  <div>
    <!-- FB提示 -->
    <el-dialog title="FBA配送单提示" :close-on-click-modal="false" :visible.sync="dialogVisible" width="580px" center>
      <div class="content">
        该配送单为FBA配送单，由FBA进行操作，请确认是否要继续操作
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  font-size: 30px;
  font-weight: bold;
  color: red;
}
</style>